import {environment} from './../../environments/environment';
export const constant = {
    REDIRECT_URL:"/",
    SMS:'sms',
    LOGIN_URL: "login", 
    ELINK_GET: "Elink/{id}/{guid}/{npi}",
    USER_REG_POST: "User",
    USER_LOGIN_POST: "User/Token",  
    USER_OTP: "User/OTP",
    USER_SEND_OTP: "User/SendOTP",
    USER_PATIENT_PHARMACY_INFO: 'User/PatientPharmacyInfo',
    USER_RESEND_OTP: "User/ResendOTP",  
    MOBILE_PAYMENT_POST: "MobilePayment",  
    USER_LOGOUT: "logout", 
    PASSWORD_VALID_REXP: /(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[@$!%*#?&^_-]).{8,}/,
    EMAIL_VALID_REXP: /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    GET_PENDINGPAYMENTS_TRANSCATION: "Transaction/GetPendingPaymentTransactions",
    GET_PENDINGPAYMENTS_GETIMAGEURLS: "Transaction/GetImageUrls",
    Get_SETUP_TRANS:"Transaction/SetupSaleTransaction",
    Get_Transaction_Signature: "Transaction/AddTransactionSignature",
    GET_SAVED_CARDS_DETAILS: "Transaction/GetSavedCardsDetails",
    GET_PATIENT_PHARMACY_INFO:"User/PatientPharmacyInfo",
    POST_PHARMACY_INFO:"User/PharmacyInfo",
    POST_USER_DETAILS:"User/Details",
    PHONE_NUMBER_TEN_DIGITS_REXP:  /^\d{10}$/,
    POST_TRANSDETAILS_INFO:"PaymentProcessor/TransactionDetail",
    /* myPrimeRx API end Points */
    POST_DASHBOARD_COUNTS: "Dashboard/DashboardCounts",
    POST_UPDATE_LOGIN_STATUS: "Patient/UpdatePatientLoginStatus",
    POST_DASHBOARD_PATIENT_INFO: "Dashboard/PatientInfo",
    POST_MYMEDS_HISTORY: "Prescription/RxHistory",
    POST_READY_FOR_PICKUP: "Prescription/ReadyForPickup",
    POST_NEW_ERXS: "Prescription/NewErxs",
    POST_GET_REFILLS_DUE: "Prescription/GetRefillsDue", 
    POST_ADD_REFILLS_QUE: "Prescription/AddToRefillQueue",
    POST_USER_DETAIL_EMAIL: "User/Details/Email",
    POST_CONVERSATION:"MyPrimeRx/Conversation",
    POST_MESSAGE_UNREADCOUNT: "api/v1/CommunicationLog/UnReadMessageCount",
    POST_MESSAGE_MARKASREAD: "api/v1/Message/MarkAsRead",
    POST_PROFILE_UPDATE: "User/UpdateProfilePicture",
    POST_PROFILE_PICTUREID: "Patient/UpdateProfilePicture",
    DELETE_PROFILE_PICTURE: "User/DeleteProfilePicture",
    NEGOTIAGE:"negotiate",
    GENERAL: 'General',
    BIRTHDAY: 'Birthday', 
    PENDING_PAYMENTS: 'pendingPayments',
    CHAT:'chat',
    MY_MEDS: 'myMeds',
    READY_TO_DISPENSE: 'readyToDispense',
    NEW_PRESSCRIPTION: 'newPrescription',
    REFILLS_DUE: 'refillsDue',
    SUBSCRIPTION: 'Subscription',
    UNSUBSCRIBE: 'UnSubscribe',
    UPDATE_SUBSCRIPTION: 'User/UpdateSubscription',
    NO_DATA_FOUND:'No data found',
    unAuth_Admin_MSG:'Unable to authorize, please contact the pharmacy.',
    user_not_found_MSG:'User not found, please contact administrator.',
    trans_fialed_MSG:'Please try again or contact administrator.',
    trans_details_MSG:'Transaction details missing or invalid',
    CHAT_PAGE_MIN:0,
    CHAT_PAGE_MAX:100,
    POST_SIGNATURE:"Patient/SaveSignature",
    POST_DELETE_SIGNATURE:"Patient/DeleteSignature",
    POST_UpdatePatientDetails:"Patient/UpdatePatientDetails",
    //Patient Insurance End Points
    POST_ADD_INSURANCE : "Patient/AddNewInsuranceByPatient",
    POST_GET_INSURANCEFILE : "Patient/GetInsurancesFromInsuranceFile/{npi}",
    POST_ISINSURANCE_EXIST : "Patient/IsInsuranceExist",
    GET_CHECK_INSURANCE_ACTIVE : "Patient/CheckIfInsuranceIsActive/{insurerId}/{npi}",
    POST_ADD_EXIST_INSURANCE : "Patient/AddAdditionalInsurance",
    GET_OCR_INSURANCE_INFO : "User/ScanInsuranceCard",
    POST_OCR_TO_BLOB_INSURANCE : "User/UploadInsuranceCard",
     POST_UPLOAD_IMAGE : "Documents/UploadDocument",
     POST_DOWNLOAD_IMAGE : "Documents/DownloadDocument",
     POST_DELETE_IMAGE : "Documents/DeleteDocument",
     
    //External Meds(Rxs) Endpoints
    GET_PRIMERX_USER_ID : "Patient/GetMyPrimeRxUserId",
    GET_DRUG_INFO : "Drug/SearchDrug",
    GET_DRUG_ID : "Drug/GetDrugId",
    ADD_EXTERNAL_MEDS : "Patient/AddExternalHistory",
    GET_EXTERNAL_MEDS : "Patient/GetExternalHistory/{patientId}",
    UPDATE_EXTERNAL_MEDS : "Patient/UpdateExternalHistory",
    DELETE_EXTERNAL_MEDS : "Patient/DeleteExternalHistory",
    GET_PHARMACY_INFO : "Patient/GetTransferPharmacyInfo",
    GET_OR_CREATE_TRANSFER_PHARMACY : "User/GetOrCreateTransferPharmacy",
    GET_TRANSFER_ELINK : "Patient/GetTransferInELink",

    // payment

    POST_PAYMENT: "Transaction/CardSaleTransaction",
    POST_SaveTransactionAndSignature : "Transaction/SaveTransactionAndSignature",
    POST_UpdateCardDetails : "Transaction/UpdateCardDetails",
    POST_DeleteCardDetails : "Transaction/DeleteCardDetails",

    // Bucket transID resolution
    POST_GetPermanentTransId : "Transaction/GetPermanentTransId",
}